/* eslint-disable import/prefer-default-export */
import curriedNamespaceAction from "../../../reducers/helpers";

const REDUCER_TDP_TASK = "tdpNavigation";
const wrap = curriedNamespaceAction(REDUCER_TDP_TASK);

export const saveNavigationListings = (navigationListings) =>
  wrap({ type: "SAVE_PREV_NEXT_LISTINGS", navigationListings });
